module.exports = __webpack_public_path__ + "img/about_1.9fab6e1c.png";